/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import {
	Flex,
	NumberInput as NativeNumberInput,
	NumberInputProps,
} from '@mantine/core';

// I18n
import { useTranslation } from 'react-i18next';

// Style
import classes from './NumberInput.module.css';

// Icons
import { IconExclamationCircle } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const NumberInput = (props: NumberInputProps) => {
	const { t } = useTranslation();
	const { error, ...restProps } = props;
	/* ******************************** RENDERING ******************************* */
	return (
		<NativeNumberInput
			classNames={{
				input: !error
					? classes.input
					: classes.inputError,
				error: classes.error,
				label: classes.label,
			}}
			error={t(error ? String(error) : '')}
			withErrorStyles={true}
			rightSectionPointerEvents="none"
			autoComplete="new-password"
			rightSection={
				error && (
					<Flex pr={'5px'}>
						<IconExclamationCircle
							className={classes.errorIcon}
							color="var(--mantine-color-error)"
						/>
					</Flex>
				)
			}
			{...restProps}
		/>
	);
};
